import {ComponentProps, forwardRef} from 'react';
import {Box, chakra} from '@chakra-ui/react';
import {Svg} from 'ui-kit';

interface IProps extends ComponentProps<typeof chakra.button> {
  displayText: string;
  filled: boolean;
  isOpen: boolean;
}

export const PickerTrigger = forwardRef<HTMLButtonElement, IProps>(
  ({displayText, filled, isOpen, disabled, ...rest}, ref) => (
    <chakra.button
      ref={ref}
      type={'button'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'space-between'}
      gap={'8px'}
      w={'100%'}
      h={'44px'}
      px={'12px'}
      fontSize={'16px'}
      textAlign={'left'}
      color={filled ? '{colors.textPrimary}' : '{colors.textTertiary}'}
      background={'{colors.white}'}
      border={'thin solid'}
      borderColor={isOpen ? '{colors.textPrimary}' : '{colors.bgMain}'}
      borderRadius={'4px'}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      opacity={disabled ? 0.8 : 1}
      transition={'border-color var(--tr-100-ei)'}
      _hover={{borderColor: disabled ? '{colors.bgMain}' : '{colors.textPrimarySuperLight}'}}
      disabled={disabled}
      {...rest}
    >
      <Box as={'span'} truncate>
        {displayText}
      </Box>
      <Svg name={'Calendar'} size={'s20'} />
    </chakra.button>
  )
);

PickerTrigger.displayName = 'PickerTrigger';
